import { getDownloadLink } from '../../utils/api';

const getFile = async (imageEntry) => {
    if (!imageEntry?.file?.path) return null;
    try {
        const downloadRes = await getDownloadLink(imageEntry.file);
        return {
            file: downloadRes,
            timestamp: imageEntry.timestamp || null,
        };
    } catch (err) {
        console.error(`Failed to fetch asset: ${imageEntry.file.path}`, err);
        return null;
    }
};

export const fetchModelAssets = async (model) => {
    const primaryImages = model.primaryImages
        ? await Promise.all(model.primaryImages.map(getFile))
        : [];

    const secondaryImages = model.secondaryImages
        ? await Promise.all(model.secondaryImages.map(getFile))
        : [];

    // Fetch thumbnail
    const thumbnail = fetchCurrThumbnail(model);

    // Fetch fitting images
    const fittingImages = model.fittingSections
        ? await Promise.all(
            model.fittingSections
                .filter((section) => section !== null) // Filter out null entries
                .map(async (section) => ({
                    client: section.client,
                    category: section.category,
                    date: section.date,
                    images: await Promise.all(
                        (section.images || []).map(getFile)
                    ),
                }))
        )
        : [];

    // Fetch files
    const files = model.files
        ? await Promise.all(model.files.map(getFile))
        : [];
    return {
        thumbnail,
        primaryImages: primaryImages.filter(Boolean),
        secondaryImages: secondaryImages.filter(Boolean),
        fittingImages,
        files
    };
};

export const fetchCurrThumbnail = async (model) => {
    // Fetch thumbnail
    return model.largeThumb?.file
        ? await getFile(model.largeThumb)
        : null;
}
